// Bundle cards (line-cards-bundles.liquid): header sync on card switch +
// AJAX add-to-cart of the selected real variant (Bundles-app bundle or product).
// Unlike the old ab-oct.js flow there is NO cart clearing and NO checkout
// redirect: the item is added via /cart/add.js and the cart drawer opens.
document.addEventListener("DOMContentLoaded", () => {
  const addToCart = document.querySelector(".dynamicAbButton");
  const inputs = Array.from(
    document.querySelectorAll(".product-variant-card__item input"),
  );
  if (!addToCart || inputs.length === 0) return;

  const priceBox = document.querySelector(".gppCustom");
  const perUseBox = document.querySelector(".gppPerUse");
  const varTitle = document.querySelector(".gppVariantTitle");
  const bestTitle = document.querySelector(".gppValueTitle");
  const mainTitle = document.querySelector(".new-product-single__title");

  // Bundle gallery override: swaps the main gallery photo (slide 1 / thumb 1)
  // when the selected card has a "Bundle selected main gallery image" set.
  // Mirrors lp-hs-offer.liquid's syncFirstGalleryImage on LP_HS_Main_v2.
  let firstSlideDefaults = null;
  let firstSlideModified = false;

  // The main slide's plain src attribute can be a broken relative path (a
  // pre-existing double image_url-filter bug in media-r.liquid) while its
  // srcset is correctly absolute — prefer the largest srcset candidate.
  function getBestImageUrl(img) {
    const srcset = img.getAttribute("srcset");
    if (srcset) {
      const candidates = srcset.split(",").map((s) => s.trim());
      const last = candidates[candidates.length - 1];
      const url = last ? last.split(/\s+/)[0] : "";
      if (url) return url;
    }
    return img.currentSrc || img.src;
  }

  function getFlickityInstance(sectionId) {
    if (!sectionId || !window.theme || !theme.sections) return null;
    const instance = theme.sections.instances.filter(
      (i) => i.id === sectionId,
    )[0];
    return instance && instance.flickity ? instance.flickity : null;
  }

  function syncBundleGalleryImage(input) {
    const container = input.closest("[data-section-id]");
    if (!container) return;

    const mainImg = container.querySelector(
      '[data-product-photos] .product-main-slide[data-index="0"] img',
    );
    if (!mainImg) return;
    const thumbImg = container.querySelector(
      '[data-product-thumbs] .product__thumb-item[data-index="0"] img',
    );
    const thumbLink = container.querySelector(
      '[data-product-thumbs] a.product__thumb[data-index="0"]',
    );

    if (!firstSlideDefaults) {
      firstSlideDefaults = {
        mainSrc: getBestImageUrl(mainImg),
        mainSrcset: mainImg.getAttribute("srcset") || "",
        thumbSrc: thumbImg ? getBestImageUrl(thumbImg) : "",
        thumbHref: thumbLink ? thumbLink.getAttribute("href") : "",
      };
    }

    const bundleImage = input.dataset.bundleImage || "";
    let didChange = false;

    if (bundleImage) {
      mainImg.src = bundleImage;
      mainImg.removeAttribute("srcset");
      if (thumbImg) thumbImg.src = bundleImage;
      if (thumbLink) thumbLink.setAttribute("href", bundleImage);
      firstSlideModified = true;
      didChange = true;
    } else if (firstSlideModified) {
      mainImg.src = firstSlideDefaults.mainSrc;
      if (firstSlideDefaults.mainSrcset) {
        mainImg.setAttribute("srcset", firstSlideDefaults.mainSrcset);
      }
      if (thumbImg) thumbImg.src = firstSlideDefaults.thumbSrc;
      if (thumbLink) thumbLink.setAttribute("href", firstSlideDefaults.thumbHref);
      firstSlideModified = false;
      didChange = true;
    }

    if (didChange) {
      const flickity = getFlickityInstance(
        container.getAttribute("data-section-id"),
      );
      if (flickity && typeof flickity.goToSlide === "function") {
        flickity.goToSlide(0);
      }
    }
  }

  const offers = document.querySelectorAll("[data-bundle-offer]");

  // Offer heading + gifts above the gallery (bundle-offer.liquid) follow the selected card.
  function syncBundleOffer(input) {
    offers.forEach((offer) => {
      offer.hidden = offer.dataset.bundleOffer !== input.id;
    });
  }

  function updateHeader(input) {
    const price = input.parentElement.getAttribute("data-variant-price") || "";
    const compare = input.dataset.compare || "";
    const savings = input.dataset.savings || "";
    const currency = input.dataset.currency || "";
    const subtitle = input.dataset.variant || "";
    const best = input.dataset.best || "";
    const title = input.parentElement.getAttribute("data-value") || "";
    const variantId = input.dataset.vid || "";

    let html = `<span class="price">${price}</span>`;
    if (compare && compare !== price) {
      html += `<span class="compare">${compare} ${currency}</span>`;
    }
    if (savings) {
      html += `<span class="gridPriceSavingsCtn"><span class="gridPriceSavings">${savings}</span></span>`;
    }

    if (priceBox) priceBox.innerHTML = html;
    if (perUseBox) {
      const phrases = (input.dataset.perUse || "").split(" · ");
      const items = [0, 1, 2, 3].flatMap((copy) =>
        phrases.map((phrase) => {
          const item = document.createElement("span");
          item.className = "gppPerUse__item";
          item.textContent = phrase;
          if (copy > 0) item.setAttribute("aria-hidden", "true");
          return item;
        }),
      );
      const track = perUseBox.querySelector(".gppPerUse__track");
      track.textContent = "";
      track.append(...items);
      perUseBox.hidden = !input.dataset.perUse;
    }
    if (varTitle) varTitle.innerHTML = subtitle;
    if (bestTitle) bestTitle.innerHTML = best;
    if (mainTitle) mainTitle.textContent = title;

    if (variantId) {
      addToCart.setAttribute("data-current-id", variantId);
      addToCart.setAttribute("data-fallback-url", "/cart/" + variantId + ":1");
    }

    syncBundleOffer(input);
    syncBundleGalleryImage(input);
  }

  inputs.forEach((input) => {
    input.addEventListener("change", () => {
      if (input.checked) updateHeader(input);
    });
  });

  // Init from the pre-selected card so data-current-id is always set.
  const checkedInput = inputs.find((i) => i.checked);
  if (checkedInput) updateHeader(checkedInput);

  addToCart.addEventListener("click", async (e) => {
    e.preventDefault();

    const variantId = addToCart.getAttribute("data-current-id");
    if (!variantId) return;
    if (addToCart.classList.contains("ab-bundle-loading")) return;

    const originalText = addToCart.innerHTML;
    addToCart.classList.add("ab-bundle-loading");
    addToCart.innerHTML = "<span>Adding...</span>";
    addToCart.style.pointerEvents = "none";

    try {
      if (window.ShopifyCartCache) {
        window.ShopifyCartCache.data = null;
        window.ShopifyCartCache.timestamp = 0;
      }

      // Don't add a second unit if the same variant is already in cart.
      const currentCart = await fetch("/cart.js").then((r) => r.json());
      const alreadyInCart =
        currentCart.items &&
        currentCart.items.some(
          (i) => String(i.variant_id) === String(variantId),
        );

      if (!alreadyInCart) {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
        });
        if (!response.ok) throw new Error("add.js failed");
        if (window.ShopifyCartCache) {
          window.ShopifyCartCache.data = null;
          window.ShopifyCartCache.timestamp = 0;
        }
      }

      const giftConfig = window.LPOfferGiftConfig || {};
      const cartDrawerEl = document.getElementById("cartDrawer");

      if (
        typeof window.syncLPGifts === "function" &&
        Object.keys(giftConfig).length > 0
      ) {
        // Gift-sync scheme: gifts live outside the bundle, a Buy X Get Y
        // discount makes them free; syncLPGifts re-renders the drawer.
        if (cartDrawerEl) cartDrawerEl.setAttribute("data-mutated", "true");
        if (typeof window.cartDrawerOpen === "function") window.cartDrawerOpen();
        await window.syncLPGifts();
      } else if (cartDrawerEl) {
        cartDrawerEl.setAttribute("data-mutated", "false");
        if (typeof window.initializeCartDrawer === "function") {
          await window.initializeCartDrawer(e);
        } else if (typeof window.cartDrawerOpen === "function") {
          window.cartDrawerOpen();
        }
      } else {
        const cartIcon = document.querySelector("#OpenCartDrawer");
        if (cartIcon) cartIcon.click();
      }

      addToCart.innerHTML = "<span>Added!</span>";
      setTimeout(() => {
        addToCart.innerHTML = originalText;
      }, 2000);
    } catch (error) {
      console.error("Error adding bundle to cart:", error);
      // Fallback: cart permalink still works without JS niceties.
      window.location.href = "/cart/" + variantId + ":1";
    } finally {
      addToCart.classList.remove("ab-bundle-loading");
      addToCart.style.pointerEvents = "all";
    }
  });
});
